const contact = {
  title: "معلومات التواصل",
  subtitle: "شارك معلومات جهة الاتصال للمتابعة.",
  name: {
    label: "اسم جهة الاتصال",
    placeholder: "أدخل اسم جهة الاتصال",
  },
  phone: {
    label: "رقم الجوال",
    placeholder: "مثال: +20 (10) 0000-0000",
  },
  email: {
    label: "البريد الإلكتروني",
    placeholder: "useremail@example.com",
  },
  password: {
    label: "كلمة المرور",
    placeholder: "أدخل كلمة المرور",
  },
  confirmPassword: {
    label: "تأكيد كلمة المرور",
    placeholder: "أكد كلمة المرور",
  },
  passwordRules: {
    minLength: "يجب ألا تقل عن 8 أحرف.",
    complexity:
      "تتضمن حرفًا كبيرًا وحرفًا صغيرًا وحرفًا خاصًا واحدًا على الأقل.",
  },
  terms: {
    title: "الشروط والأحكام",
    confirmation:
      "بالتأشير على هذا المربع، أؤكد أنني قرأت ووافقت على ",
    link: "الشروط والأحكام",
    checkboxAria: "الموافقة على الشروط والأحكام",
  },
  actions: {
    next: "التالي",
  },
};

export default contact;
